import axios from "axios";
import authHeader from "./auth-header";
import { config } from "../config";

class TargaTelematicsService {
  get(path, params = {}) {
    return axios.get(`${config.apiUrl.replace(/\/+$/, "")}/telemetry/${path}`, {
      headers: authHeader(),
      params,
    }).then((response) => response.data);
  }

  getVehicles(params = {}) {
    return this.get("vehicles", params);
  }

  getVehicleEnergy() {
    return this.get("vehicle-energy");
  }

  getVehicleByRegistration(registration) {
    return this.get(`vehicles/by-registration/${encodeURIComponent(registration)}`);
  }

  getVehicleByVin(vin) {
    return this.get(`vehicles/by-vin/${encodeURIComponent(vin)}`);
  }

  getVehicle(vin) {
    return this.get(`vehicles/${encodeURIComponent(vin)}`);
  }

  getVehicleDevices(vin) {
    return this.get(`vehicles/${encodeURIComponent(vin)}/devices`);
  }

  getVehicleDigitalTwin(vin) {
    return this.get(`digital-twin/vehicles/${encodeURIComponent(vin)}`);
  }

  getVehiclesDigitalTwins(vins) {
    return axios.post(`${config.apiUrl.replace(/\/+$/, "")}/telemetry/digital-twin/vehicles`, { vins }, {
      headers: authHeader(),
    }).then((response) => response.data);
  }

  getVehicleTrips(vin, params = {}) {
    return this.get(`trips/vehicles/${encodeURIComponent(vin)}`, params);
  }

  getVehicleTripDetails(vin, params = {}) {
    return this.get(`trips/vehicles/${encodeURIComponent(vin)}/details`, params);
  }

  getVehicleRefuels(vin, params = {}) {
    return this.get(`refuels/vehicles/${encodeURIComponent(vin)}`, params);
  }

  getVehicleCharging(vin, params = {}) {
    return this.get(`charging/vehicles/${encodeURIComponent(vin)}/recharges`, params);
  }

  getVehicleDrivingSensors(vin) {
    return this.get(`driving/vehicles/${encodeURIComponent(vin)}/sensors`);
  }

  getVehicleMaintenancePlans(vin, params = {}) {
    return this.get(`maintenance/vehicles/${encodeURIComponent(vin)}/maintenance-plans`, params);
  }

  getVehicleMaintenancePlan(vin, planId) {
    return this.get(`maintenance/vehicles/${encodeURIComponent(vin)}/maintenance-plans/${encodeURIComponent(planId)}`);
  }

  getVehicleHealth(vin, params = {}) {
    return this.get(`vehicle-health/vehicles/${encodeURIComponent(vin)}`, params);
  }
}

export default new TargaTelematicsService();
